export enum DEFINING_REQUESTS {
    Config = 'Config',
    CseDopSet = 'CseDopSet',
    DeepInsert = 'DeepInsert',
    F4mPrologueSet = 'F4mPrologueSet',
    F4mReleaseLockSet = 'F4mReleaseLockSet',
    F4mSaveXmlSet = 'F4mSaveXmlSet',
    F4mSubmitFormSet = 'F4MSubmitFormSet',
    F4mUploadSignatureSet = 'F4mUploadSignatureSet',
    InputFieldProperties = 'InputFieldProperties',
    NotificationCancellation = 'NotificationCancellation',
    Notifications = 'NotificationsExpanded',
    StatusUpdate = 'StatusUpdate',
    ValueHelpers = 'ValueHelpers',
    WhatsNew = 'WhatsNew',
    WorkSchedule = 'WorkSchedule',
    MatStock = 'MatStock',
    EncryptionKey = 'EncryptionKey',
    RequestNotification = 'RequestNotification',
}
